/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargingDataDto } from '../../models/charging-data-dto';

export interface GetChargingDataListGet$Json$Params {
  parkingPlaceId?: number;
}

export function getChargingDataListGet$Json(http: HttpClient, rootUrl: string, params?: GetChargingDataListGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargingDataDto>>> {
  const rb = new RequestBuilder(rootUrl, getChargingDataListGet$Json.PATH, 'get');
  if (params) {
    rb.query('parkingPlaceId', params.parkingPlaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChargingDataDto>>;
    })
  );
}

getChargingDataListGet$Json.PATH = '/GetChargingDataList';
